import * as React from 'react';

import {RightFrame, ModalMain, NavButtons} from 'shells/modal/step-modal/layout';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';

type Props = {
    header: string;
    subheader?: string;
    children: React.ReactNode;
    navButtons: React.ReactNode;
};

export function CalendarModalPage(props: Props) {
    return (
        <RightFrame>
            <ModalMain fullheight={true}>
                <ModalHeader>{props.header}</ModalHeader>
                {props.subheader && <ModalSubheader>{props.subheader}</ModalSubheader>}
                {props.children}
            </ModalMain>
            <NavButtons>{props.navButtons}</NavButtons>
        </RightFrame>
    );
}
